import clsx from 'clsx'
import { useTranslation } from 'react-i18next'
import { useDiscover } from '../../hooks/useDiscover'

export default function DimensionPreviewMessage({ className }) {
  const { t } = useTranslation()
  const {
    enableAssistant,
    setAssistantDetail,
    sendMessageToAssistant,
    setAssistantIsTyping
  } = useDiscover()

  const handleDimensionClick = () => {
    // Find the real dimensions section
    const dimensionsSection =
      document.querySelector('[data-testid="dimension-breakdown"]') ||
      document.querySelector('.dimension-breakdown') ||
      document.querySelector('[class*="dimension"]') ||
      document.querySelector('[role="button"]')

    if (dimensionsSection) {
      // Scroll to dimensions
      dimensionsSection.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      })

      // Find the first clickable dimension button
      const firstDimensionButton =
        dimensionsSection.querySelector('[role="button"]') ||
        dimensionsSection.querySelector('.cursor-pointer') ||
        dimensionsSection.querySelector('[class*="text-buttonSecondaryBlue"]')

      if (firstDimensionButton) {
        // Add a pulsing highlight effect
        const originalStyle = {
          boxShadow: firstDimensionButton.style.boxShadow,
          transform: firstDimensionButton.style.transform,
          transition: firstDimensionButton.style.transition
        }

        // Apply highlight effect
        firstDimensionButton.style.transition = 'all 0.3s ease'
        firstDimensionButton.style.boxShadow =
          '0 0 0 3px rgba(59, 130, 246, 0.5), 0 0 20px rgba(59, 130, 246, 0.3)'
        firstDimensionButton.style.transform = 'scale(1.02)'

        // Pulse effect
        let pulseCount = 0
        const pulseInterval = setInterval(() => {
          firstDimensionButton.style.boxShadow =
            pulseCount % 2 === 0
              ? '0 0 0 3px rgba(59, 130, 246, 0.5), 0 0 20px rgba(59, 130, 246, 0.3)'
              : '0 0 0 3px rgba(59, 130, 246, 0.3), 0 0 15px rgba(59, 130, 246, 0.2)'
          pulseCount++

          if (pulseCount >= 6) {
            // Pulse 3 times
            clearInterval(pulseInterval)
            // Restore original styles
            firstDimensionButton.style.boxShadow = originalStyle.boxShadow
            firstDimensionButton.style.transform = originalStyle.transform
            firstDimensionButton.style.transition = originalStyle.transition
          }
        }, 500)
      }
    } else {
      // Fallback: just scroll down
      window.scrollBy({
        top: 400,
        behavior: 'smooth'
      })
    }
  }

  return (
    <div className={clsx('w-full', className)}>
      {/* Interaction hint text */}
      <div className='mb-3 text-base font-normal text-darkBlack'>
        {t('discover.assistant.matching_score.interaction_hint')}
      </div>

      {/* Example dimension preview */}
      <div
        className='cursor-pointer rounded-lg border border-lightGrey bg-paleGrey p-3 transition-colors hover:bg-gray-100'
        onClick={handleDimensionClick}
      >
        <div className='flex items-center gap-2'>
          {/* Color indicator bar */}
          <div className='h-5 w-2 rounded-sm bg-brightGreen'></div>

          {/* Dimension name */}
          <span className='text-sm font-medium text-buttonSecondaryBlue hover:underline'>
            Problemlösefähigkeit
          </span>

          {/* Click hint */}
          <span className='text-xs text-mediumGrey'>← Klick mich!</span>
        </div>
      </div>

      {/* Additional hint */}
      <div className='mt-2 text-xs text-mediumGrey'>
        So sehen die klickbaren Dimensionen aus 👆 Klicke hier, um zu den echten
        Dimensionen zu springen!
      </div>
    </div>
  )
}
